/**
 * Exporte la zone d'affichage des lettres animées en vidéo MP4/WebM
 * Utilise getDisplayMedia pour capturer l'onglet (évite le canvas tainted par CORS)
 */
const INTRO_STATIC_MS = 1000; // 1 seconde sur la première frame
const ANIMATION_DURATION_MS = 7000; // 7 secondes d'animation

export async function exportAnimatedVideo(containerRef, bgColor = '#FFFFFF', durationMs, onReadyToRecord) {
  const totalDuration = (durationMs || ANIMATION_DURATION_MS) + INTRO_STATIC_MS;
  let stream;
  try {
    stream = await navigator.mediaDevices.getDisplayMedia({
      video: { displaySurface: 'browser' },
      audio: false
    });
  } catch (err) {
    if (err.name === 'NotAllowedError') {
      throw new Error('Capture annulée. Autorisez le partage d\'écran pour exporter.');
    }
    throw err;
  }

  const mimeType = MediaRecorder.isTypeSupported('video/webm;codecs=vp9')
    ? 'video/webm;codecs=vp9'
    : MediaRecorder.isTypeSupported('video/webm')
      ? 'video/webm'
      : 'video/mp4';
  const mediaRecorder = new MediaRecorder(stream, {
    mimeType,
    videoBitsPerSecond: 2500000
  });

  const chunks = [];
  mediaRecorder.ondataavailable = (e) => {
    if (e.data.size > 0) chunks.push(e.data);
  };

  return new Promise((resolve, reject) => {
    mediaRecorder.onstop = () => {
      stream.getTracks().forEach(t => t.stop());
      const blob = new Blob(chunks, { type: mediaRecorder.mimeType });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `synesthesia-export-${Date.now()}.${mediaRecorder.mimeType.includes('mp4') ? 'mp4' : 'webm'}`;
      a.click();
      URL.revokeObjectURL(url);
      resolve();
    };

    mediaRecorder.onerror = (e) => {
      stream.getTracks().forEach(t => t.stop());
      reject(e.error || new Error('Erreur d\'enregistrement'));
    };

    mediaRecorder.start(1000);

    // t=0 : afficher vidéos figées sur première frame
    if (typeof onReadyToRecord === 'function') onReadyToRecord('intro');

    setTimeout(() => {
      if (typeof onReadyToRecord === 'function') onReadyToRecord('playing');
    }, INTRO_STATIC_MS);

    setTimeout(() => {
      if (mediaRecorder.state === 'recording') {
        if (typeof mediaRecorder.requestData === 'function') mediaRecorder.requestData();
        mediaRecorder.stop();
      }
    }, totalDuration);
  });
}
